<template>
  <div id="history-view">
    <div :v-if="!gettingHistoryCompleted">
      <p v-if="gettingHistory">Waiting for server response..</p>
      <p v-if="gettingHistoryError">Error in server response..</p>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="uploadsHistoryTableData"
        item-key="generatedProductsUpdate"
        sort-by="date"
        class="elevation-2 my-5"
        multi-sort
        height="1000px"
        :items-per-page="50"
        :loading="gettingHistory"
        loading-text="Loading... Please wait"
        :footer-props="{'items-per-page-options':[10, 20, 30, 50, 100]}"
        dense
        fixed-header
        caption="History table"
        show-group-by
      >
        <template #[`item.productUpdateTemplate`]="{ item }">
          <a target="_blank" :href="item.productUpdateTemplate">
            link to file
          </a>
        </template>
        <template #[`item.bookkeepingFile`]="{ item }">
          <a target="_blank" :href="item.bookkeepingFile">
            link to file
          </a>
        </template>
        <template #[`item.generatedProductsUpdate`]="{ item }">
          <a target="_blank" :href="item.generatedProductsUpdate">
            link to file
          </a>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'history',
  data() {
    return {
    }
  },
  computed: {
    ...mapState('historyTable', [
      'uploadsHistoryTableData',
      'gettingHistory',
      'gettingHistoryError',
      'gettingHistoryCompleted',
    ]),
    
    headers() {
      return [
        { value: 'date', text: 'Date', filterable: true, groupable: false, },
        { value: 'user', text: 'User', filterable: true, groupable: true },
        { value: 'productUpdateTemplate', text: 'Uploaded Product Update Template', filterable: false, groupable: false, },
        { value: 'bookkeepingFile', text: 'Uploaded Bookkeeping File', filterable: false, groupable: false, },
        { value: 'generatedProductsUpdate', text: 'Generated Product Update File', filterable: false, groupable: false, },
      ]
    },
  },
  created() {
    this.$store.dispatch('historyTable/getHistory');
  },
  methods: {
    linkClicked({rowData, colData, rowIndex, colIndex}) {
      const url = rowData[colData['field']];
      window.open(url, '_blank');
    },
  }
};
</script>


<style>

.uploads-history {
  height: 700px;
}

</style>



// WEBPACK FOOTER //
// src/views/History.vue